// extracted by mini-css-extract-plugin
export default {"logo_container":"logo_container__22eHt","no_games":"no_games__1oktT"};